import newsBgImg from 'images/news/newsBg.webp';
import newsDetailBgImg from 'images/news/newsDetailBg.webp';
import relatedPostsImg from 'images/news/relatedPosts.webp';

export const newsBg = (newsBgImg as any).src || newsBgImg;
export const newsDetailBg = (newsDetailBgImg as any).src || newsDetailBgImg;
export const relatedPosts = (relatedPostsImg as any).src || relatedPostsImg;